/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PermissionSet } from './PermissionSet';
import {
    PermissionSetFromJSON,
    PermissionSetFromJSONTyped,
    PermissionSetToJSON,
    PermissionSetToJSONTyped,
} from './PermissionSet';
import type { RoleInfo } from './RoleInfo';
import {
    RoleInfoFromJSON,
    RoleInfoFromJSONTyped,
    RoleInfoToJSON,
    RoleInfoToJSONTyped,
} from './RoleInfo';

/**
 * 
 * @export
 * @interface PermissionData
 */
export interface PermissionData {
    /**
     * 
     * @type {boolean}
     * @memberof PermissionData
     */
    crossTenant?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PermissionData
     */
    tenantId?: string;
    /**
     * 
     * @type {{ [key: string]: PermissionSet; }}
     * @memberof PermissionData
     */
    permissions?: { [key: string]: PermissionSet; };
    /**
     * 
     * @type {Array<RoleInfo>}
     * @memberof PermissionData
     */
    roles?: Array<RoleInfo>;
    /**
     * 
     * @type {boolean}
     * @memberof PermissionData
     */
    isCrossTenant?: boolean;
}

/**
 * Check if a given object implements the PermissionData interface.
 */
export function instanceOfPermissionData(value: object): value is PermissionData {
    return true;
}

export function PermissionDataFromJSON(json: any): PermissionData {
    return PermissionDataFromJSONTyped(json, false);
}

export function PermissionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionData {
    if (json == null) {
        return json;
    }
    return {
        
        'crossTenant': json['crossTenant'] == null ? undefined : json['crossTenant'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
        'permissions': json['permissions'] == null ? undefined : (mapValues(json['permissions'], PermissionSetFromJSON)),
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(RoleInfoFromJSON)),
        'isCrossTenant': json['is_cross_tenant'] == null ? undefined : json['is_cross_tenant'],
    };
}

export function PermissionDataToJSON(json: any): PermissionData {
    return PermissionDataToJSONTyped(json, false);
}

export function PermissionDataToJSONTyped(value?: PermissionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'crossTenant': value['crossTenant'],
        'tenant_id': value['tenantId'],
        'permissions': value['permissions'] == null ? undefined : (mapValues(value['permissions'], PermissionSetToJSON)),
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(RoleInfoToJSON)),
        'is_cross_tenant': value['isCrossTenant'],
    };
}

